function FoodCard({ food }) {
  const getButtonLabel = (link) => {
    if (link.includes('ubereats') || link.includes('doordash')) {
      return 'Order Online';
    } else if (link.includes('maps')) {
      return 'Find Nearby';
    }
    return 'View Options';
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border p-4 hover:shadow-md transition">
      <h3 className="text-lg font-bold text-gray-900 mb-2">
        {food.food}
      </h3>
      <p className="text-gray-600 text-sm mb-4 leading-relaxed">
        {food.reason}
      </p>
      <a
        href={food.link}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block bg-black text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-800 transition"
      >
        {getButtonLabel(food.link)}
      </a>
    </div>
  );
}

export default FoodCard;
